import { render, staticRenderFns } from "./EditBaseTemplate.vue?vue&type=template&id=3e513218&scoped=true"
import script from "./EditBaseTemplate.vue?vue&type=script&lang=js"
export * from "./EditBaseTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditBaseTemplate.vue?vue&type=style&index=0&id=3e513218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e513218",
  null
  
)

export default component.exports